import React from 'react';

const Head = ({ onSortChange }) => {
    return (
        <thead>
            <tr>
                <th onClick={() => onSortChange(`source`)}>Source</th>
                <th onClick={() => onSortChange(`affid`)}>Affid</th>
                <th onClick={() => onSortChange(`country`)}>Country</th>
                <th onClick={() => onSortChange(`impressions`)}>Impressions</th>
                <th onClick={() => onSortChange(`clicks`)}>Clicks</th>
                <th onClick={() => onSortChange(`revenue`)}>Revenue</th>
                <th onClick={() => onSortChange(`ctr`)}>CTR</th>
            </tr>
        </thead>
    )
};

export default Head;


// WEBPACK FOOTER //
// ./src/scenes/BidderCtr/components/Table/components/Head/index.js